module.exports = __webpack_public_path__ + "img/team_strength_img.4a010385.png";